/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {SearchableItem} from './searchable.item';

export class SearchableSelection {
  NAME: string;
  TYPE: SearchableSelectionType;
  VALUE: any;

  constructor(item: SearchableItem) {
    this.NAME = item.getName();
    this.TYPE = item.getType();
    this.VALUE = item.getValue();
  }
}

export enum SearchableSelectionType {
  VALUE = 'VALUE', // User, Client, ClientUser
  SCRIPT = 'SCRIPT' // PresetValue
}
